import { decodeAuthToken } from './decodeAuthToken';

export const isAuthToken = (token: string) => {
    const decodedToken = decodeAuthToken(token);

    return decodedToken?.hasOwnProperty('userId') && decodedToken?.hasOwnProperty('sync');
};
